// App.js
import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import TractateList from './pages/TractateList';
import TractateDetail from './pages/TractateDetail';
import YearPlan from './pages/YearPlan';
import TopicList from './pages/TopicList';
import TopicDetail from './pages/TopicDetail';
import TopicFiles from './pages/TopicFiles';
import About from './pages/About';
import InspGreet from './pages/InspGreet';
import EmergencyMaterials from './pages/EmergencyMaterials';
import AuxiliaryFolderDetail from './pages/AuxiliaryFolderDetail';
import Layout from './components/Layout';

function AppRoutes() {
  return (
    <Routes>
      {/* Root → tractates */}
      <Route path="/" element={<Navigate to="/tractates" />} />

      {/* Public app (no auth) */}
      <Route element={<Layout />}>
        <Route path="/tractates" element={<TractateList />} />
        <Route path="/auxiliary/:folderId" element={<AuxiliaryFolderDetail />} />
        <Route path="/tractates/:id" element={<TractateDetail />} />
        <Route path="/tractates/:id/year-plan" element={<YearPlan />} />
        <Route path="/tractates/:id/auxiliary/:folderId" element={<AuxiliaryFolderDetail />} />
        <Route path="/tractates/:id/topics" element={<TopicList />} />
        <Route path="/tractates/:id/topics/:topicId" element={<TopicDetail />} />
        <Route path="/tractates/:id/topics/:topicId/preparation" element={<TopicFiles type="PREP" />} />
        <Route path="/tractates/:id/topics/:topicId/tools" element={<TopicFiles type="TOOLS" />} />
        <Route path="/tractates/:id/topics/:topicId/evaluation" element={<TopicFiles type="EVAL" />} />
        <Route path="/tractates/:id/topics/:topicId/visual" element={<TopicFiles type="VISUAL_TALMUD" />} />
        <Route path="/tractates/:id/topics/:topicId/tosafot" element={<TopicFiles type="TOSFOT_IYYUN" />} />
        <Route path="/emergency" element={<EmergencyMaterials />} />
        <Route path="/about" element={<About />} />
        <Route path="/inspGreet" element={<InspGreet />} />
      </Route>
    </Routes>
  );
}

export default function WrappedApp() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

/*
  import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import TractateList from './pages/TractateList';
import TractateDetail from './pages/TractateDetail';
import YearPlan from './pages/YearPlan';
import TopicList from './pages/TopicList';
import TopicDetail from './pages/TopicDetail';
import TopicFiles from './pages/TopicFiles';
import Login from './pages/Login';
import Register from './pages/Register';
import Logout from './pages/Logout';
import About from './pages/About';
import Layout from './components/Layout';

function ProtectedRoute({ children }) {
  const access = localStorage.getItem('access');
  return access ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  return (
    <Routes>
      //Public
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      //Protected: wrapped with Layout (topbar + right sidebar)
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/tractates" element={<TractateList />} />
        <Route path="/tractates/:id" element={<TractateDetail />} />
        <Route path="/tractates/:id/year-plan" element={<YearPlan />} />
        <Route path="/tractates/:id/topics" element={<TopicList />} />
        <Route path="/tractates/:id/topics/:topicId" element={<TopicDetail />} />
        <Route path="/tractates/:id/topics/:topicId/preparation" element={<TopicFiles type="PREP" />} />
        <Route path="/tractates/:id/topics/:topicId/tools" element={<TopicFiles type="TOOLS" />} />
        <Route path="/tractates/:id/topics/:topicId/evaluation" element={<TopicFiles type="EVAL" />} />
        <Route path="/tractates/:id/topics/:topicId/visual" element={<TopicFiles type="VISUAL_TALMUD" />} />
        <Route path="/tractates/:id/topics/:topicId/tosafot" element={<TopicFiles type="TOSFOT_IYYUN" />} />
         <Route path="/about" element={<About />} />

        <Route path="/logout" element={<Logout />} />
      </Route>
    </Routes>
  );
}

export default function WrappedApp() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
*/